export const HEADER_ANIMATION_DURATION = 4800;
export const LAST_ITEM_ANIMATION_DURATION = 5400;
export const GAME_CARDS_ANIMATION_DURATION = 6000;
export const BUFFER_DURATION = 500;
export const TOTAL_ANIMATION_DURATION =
  HEADER_ANIMATION_DURATION +
  LAST_ITEM_ANIMATION_DURATION +
  GAME_CARDS_ANIMATION_DURATION +
  BUFFER_DURATION;
